import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ApiService from "../../../../network/ApiService";

function PaymentGateway(props) {
  const { fetchPaymentGatewayList } = ApiService();
  const { organizationId } = useSelector((state) => state.organization);
  const [paymentGatewayList, setPaymentGatewayList] = useState([]);

  const getPaymentGatewayList = async () => {
    try {
      const response = await fetchPaymentGatewayList();
      setPaymentGatewayList(response.data.paymentGateWayDetail);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (organizationId) {
      getPaymentGatewayList();
    }
  }, [organizationId]);

  return (
    <div style={{ backgroundColor: "transparent" }}>
      {paymentGatewayList.length > 0 && (
        <div>
          {/* Heading */}
      <h5 className="uk-text-center" style={{ color: "white", fontSize: "20px", marginBottom: "10px" }}>
  <span className="underline-secondary">
    {props.language === "en" ? `Payment Partners` : `भुक्तानी साझेदार`}
  </span>
</h5>

          {/* Logos - small, horizontal, wrapping */}
          <div
            className="uk-flex uk-flex-center uk-flex-wrap"
            style={{ gap: "8px" }}
          >
            {paymentGatewayList.map((data, index) => {
              const logo =
                data.paymentGatewayLogo.trim() !== "N/A"
                  ? data.paymentGatewayLogo
                  : "assets/images/image.jpg";
              const url =
                data.payementGateWayURL !== "N/A" &&
                data.payementGateWayURL.trim() !== ""
                  ? data.payementGateWayURL
                  : null;

              return (
                <a
                  key={index}
                  href={url || "#"}
                  target={url ? "_blank" : "_self"}
                  rel="noreferrer"
                  style={{
                    display: "inline-block",
                    padding: "4px",
                    background: "white",
                    borderRadius: "3px",
                  }}
                >
               <img
  src={logo}
  width="100"   // previously 80
  height="35"   // previously 30
  alt="Payment Logo"
  loading="lazy"
  style={{ objectFit: "contain" }}
/>

                </a>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default PaymentGateway;
